import { render } from "./DiscordChannelPickerComponent.vue?vue&type=template&id=ab7b441e&scoped=true"
import script from "./DiscordChannelPickerComponent.vue?vue&type=script&lang=js"
export * from "./DiscordChannelPickerComponent.vue?vue&type=script&lang=js"

import "./DiscordChannelPickerComponent.vue?vue&type=style&index=0&id=ab7b441e&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.25_vue@3.5.25_typescript@4.9.5__webpack@5.103.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab7b441e"]])

export default __exports__